let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4VYQ6")).then(() => parcelRequire('gmJHq'));